module.exports = __webpack_public_path__ + "static/media/google-play-badge.f65d9b46.png";